import BaseListPresenter from "../../base/BaseListPresenter";
import { liveQueryUseCase } from "../../usecases/livequery";

class NotificationPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.findObjectUseCase = findObjectUseCase;
    this.countObjectUseCase = countObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
  }

  init() {
    const currentUser = this.view.getCurrentUser();

    this.limit = 20;
    this.where = {
      notify: {
        $in: [
          currentUser.id,
          currentUser.employee.id,
          `role:${currentUser.roles[0].id}`,
          "*",
        ],
      },
    };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = []; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  // componentDidMount() {
  //   this.init();
  //   this.subscribe();
  //   return this.getObjects();
  // }

  // subscribe() {
  //   const currentUser = this.view.getCurrentUser();
  //   const query = {
  //     collection: "notifications",
  //     where: {},
  //   };

  //   const insertSubscription = liveQueryUseCase().execute(query, "afterInsert");

  //   insertSubscription.on("create", (data) => {
  //     const notifyList = data.notify;
  //     const userRole = `role:${currentUser.roles[0].id}`;
  //     const employeeId = currentUser.employee.id;
  //     const userId = currentUser.id;

  //     if (
  //       notifyList.includes(userRole) ||
  //       notifyList.includes(employeeId) ||
  //       notifyList.includes(userId) ||
  //       notifyList.includes("*")
  //     ) {
  //       this.objects?.unshift(data);
  //       this.view.setObjects(this.objects);
  //     }
  //   });

  //   const updateSubscription = liveQueryUseCase().execute(query, "afterUpdate");

  //   updateSubscription.on("update", (data) => {
  //     this.objects.unshift(data);
  //     this.view.setObjects(this.objects);
  //   });

  //   [insertSubscription].forEach((subscription) => {
  //     subscription.on("error", (error) => {
  //       console.error("Subscription error:", error);
  //     });
  //   });
  // }
}

export default NotificationPresenter;
